import { useAppContext } from 'context/AppContext'

const useUser = () => {
  const { header, user } = useAppContext()
  return [header?.user || user]
}

export default useUser
